import { Stack, Typography } from '@mui/material';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { useDictionary } from 'Hooks';

interface ITextIntro {
  numberOfSections: number;
}
export const TextIntro = ({ numberOfSections }: ITextIntro) => {
  const dictionary = useDictionary(Dictionary, DICTIONARY.Status);
  return (
    <Stack width='fit-content' mb='16px'>
      <Typography variant='body2'>
        {dictionary.yourApplicationIsMadeOfInjuries(numberOfSections)}
      </Typography>
      <Typography variant='body2'>
        {dictionary.hereYouCanFollowTheirProgress}
      </Typography>
    </Stack>
  );
};
